import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Go, LoadPersonalData } from '@store/actions';
import * as fromRootStore from '@store/index';
import { selectPersonalDataLoaded } from '@store/selectors/personal-data/personal-data.selectors';
import { CookieService } from 'ngx-cookie-service';
import { catchError, Observable, of, switchMap, tap } from 'rxjs';

import { overviewRedirect } from '../launch/launch.guard';

@Injectable()
export class DataGuard {
  constructor(
    private globalStore: Store<fromRootStore.State>,
    private cookieService: CookieService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      this.globalStore.dispatch(LoadPersonalData());
      return of(true);
    }
    return this.isPersonalDataLoaded().pipe(
      switchMap((loaded) => {
        if (loaded) return of(true);
        const url = overviewRedirect(state.url);
        this.globalStore.dispatch(Go({ path: [url] }));
        return of(false);
      }),
      catchError(() => of(false)),
    );
  }

  isPersonalDataLoaded(): Observable<boolean> {
    return this.globalStore.select(selectPersonalDataLoaded).pipe(
      tap((loaded) => {
        return loaded;
      }),
    );
  }
}
